(function () {
  var b = document.querySelector('.burger'), n = document.getElementById('mainnav');
  if (b && n) b.addEventListener('click', function () {
    var o = n.classList.toggle('open'); b.setAttribute('aria-expanded', o ? 'true' : 'false');
  });
  document.querySelectorAll('.thumbs button').forEach(function (t) {
    t.addEventListener('click', function () {
      var m = document.getElementById('mainImg'); if (m) { m.src = t.dataset.src; m.removeAttribute('srcset'); }
    });
  });
})();
